<div class="flex flex-col gap-3">

    @if(hasPhoto()) {
    <img [src]="photoUrl()" class="w-full" />
    }


    <div class="flex justify-center">
        @if(hasPhoto()) {
        <p-button severity="danger" (click)="removeGroupPhoto()"><span class="p-button-label"><fa-icon
                    [icon]="icons.ppmSolid.delete"></fa-icon>
                Remove Team Photo</span></p-button>
        }
        @else {
        <div class="flex flex-col gap-3">
            <p-fileUpload #uploadComponent name="images[]" mode="basic" [auto]="false" [multiple]="false"
                accept="image/jpeg" [disabled]="uploadingGroupPhoto()" chooseLabel="Upload Group Photo"
                [url]="groupPhotoUploadUrl()" (onUpload)="onUpload($event)" 
                (onProgress)="onProgress($event)" (onSend)="onSend($event)"
                (onError)="onUploadError($event)" (onSelect)="onSelect($event)"></p-fileUpload>

            @if(uploadingGroupPhoto()) {

            <div class="flex gap-2">
                <div>Uploading Photo</div>
                <p-progressBar class="w-full" [value]="groupPhotoUploadProgress()"></p-progressBar>
            </div>
            @if(fileUploaded()) {
            <div class="flex gap-2">
                <p-progressSpinner [style]="{width: '1rem', height: '1rem'}"></p-progressSpinner>
                <div>Processing Image...</div>
            </div>
            }

            }
        </div>
        }
    </div>
</div>